import PropTypes from 'prop-types'
import React, { Component } from 'react'

class BuyPleaseWait extends Component {
  render() {
    const h1 = this.props.h1
      ? this.props.h1
      : 'Controlla la tua casella di posta'
    const p = this.props.p ? (
      this.props.p
    ) : (
      <span>
        Ti abbiamo inviato un'email per confermare il tuo indirizzo{' '}
        <span className="yellow">{this.props.email}</span>
      </span>
    )

    return (
      <div className="please-wait">
        <div className="centered">
          <i className="icon-spinner big"></i>
          <h1>{h1}</h1>
          <p>{p}</p>
        </div>
      </div>
    )
  }
}

BuyPleaseWait.propTypes = {
  email: PropTypes.string,
  h1: PropTypes.string,
  p: PropTypes.element,
}

export default BuyPleaseWait
